<template>
    <Sheet v-model:open="isOpen" class="w-screen">
        <SheetContent class="mb-auto mt-0 h-fit w-screen p-0 sm:max-w-none" side="top">
            <SheetHeader class="p-6">
                <SheetTitle>
                    <slot name="menu-brand"></slot>
                </SheetTitle>
            </SheetHeader>
            <div class="flex flex-col gap-y-6 p-6">
                <slot name="menu-links"></slot>
            </div>
        </SheetContent>
    </Sheet>
</template>

<script setup lang="ts">
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet'
import { ref } from 'vue'

const isOpen = ref(false)
</script>

<style scoped></style>
